'use strict';

import React from 'react';
import Modal from 'jsx/lib/modal';

const getReferrerDomain = () => {
  const domain = window.document.referrer.split('/')[2];
  if (!domain) {
    return '';
  }
  return domain.replace(/^www\./,'');
};

const getReferrerUrlPath = () => {
  const referrerValues = window.document.referrer.split('/');
  if (referrerValues.length <= 3) return '';
  return referrerValues.splice(3).join('/');
};

module.exports = {
  /**
   * Show the Modal. In all its glory!
   */
  togglePopup: function(content) {
    if (this.state.modal === null) {
      this.props.app.setModal(
        <Modal>
          <div dangerouslySetInnerHTML={{__html: content.src}} />
        </Modal>
      );
    }
  },

  /**
   * This sets up Google Publisher Tag (GPT) on page load, this needs to trigger everytime we change route
   */
  setupGPT: function() {
    if (/bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent)) return null;
    if (!window.isAdvertisingEnabled) return null;

    let tagArray = [];
    let postId = 'none';
    const community = this.ctx.getGroup().groupCode ? this.ctx.getGroup().groupCode : 'none';
    const isActive = this.ctx.isActive();
    let pageType = this.app.res.module ? this.app.res.module : this.app.res.action;

    if (this.app.res.controller === 'profile') {
      pageType = 'profile';
    }

    if (pageType === 'post' && this.props.pageData.post) {
      const post = this.props.pageData.post;
      tagArray = this.props.pageData.post.get('tags').map(function(tag) {
        return tag.urlEncodedName;
      });
      postId = post.get('id').toString();
    } else if (pageType === 'poll' && this.props.pageData.poll) {
      tagArray = this.props.pageData.poll.get('tags').map(function(tag) {
        return tag.urlEncodedName;
      });
    }

    googletag.cmd.push(() => {
      // set page-level key-value targeting
      googletag.pubads()
        .setTargeting('user', isActive ? 'member' : 'visitor')
        .setTargeting('branch', window.HU_TEST_BRANCH)
        .setTargeting('community', community)
        .setTargeting('post-id', postId)
        .setTargeting('terms', tagArray)
        .setTargeting('source-domain', getReferrerDomain())
        .setTargeting('source-page', getReferrerUrlPath())
        .setTargeting('page-type', pageType);

      googletag.pubads().enableSingleRequest();
      googletag.pubads().collapseEmptyDivs(true);
      googletag.enableServices(); // call all ad slots on the page in one call

      // construct ad slot
      const ad1 = googletag.defineSlot('/12650263/hucustom1', [1, 1], 'gpt-ad-1');
      const ad2 = googletag.defineSlot('/12650263/hucustom2', [1, 1], 'gpt-ad-2');
      if (ad1) ad1.addService(googletag.pubads());
      if (ad2) ad2.addService(googletag.pubads());

      // render ad slot
      googletag.display('gpt-ad-1');
      googletag.display('gpt-ad-2');
    });
  },
};



// WEBPACK FOOTER //
// ./app/assets/js/mixins/adverts.js